
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragNDropDirective } from './utils/directives/drag-n-drop.directive';
import { LimitTextPipe, TableSearchPipe, TruthyPipe } from './utils/pipes';
import { ClickOutsideDirective } from './utils/directives/click-outside.directive';
import { DndFileFolder } from './utils/directives/dnd-file.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    DragNDropDirective,
    LimitTextPipe,
    ClickOutsideDirective,
    DndFileFolder,
    TableSearchPipe,
    TruthyPipe
  ],
  exports: [
    DragNDropDirective,
    LimitTextPipe,
    ClickOutsideDirective,
    DndFileFolder,
    TableSearchPipe,
    TruthyPipe
  ],
  providers: [
    TableSearchPipe,
  ]
})
export class FeatureLibraryModule { }
        